export const visit = (vm, at) => {
at({ "en": { "crm-index-visualization-core": { "temporaryView": { "defaultName": "Filtered view" } } } });
};